import { Link } from 'react-router-dom';

function HomePage() {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1 className="hero-title">
            <span className="hero-icon">🐦</span>
            Gukni Golube
          </h1>
          <p className="hero-subtitle">Brojka ili gukni.</p>
          <p className="hero-tagline">Matematika ne laže. Populizam da.</p>
          
          <div className="hero-cta">
            <Link to="/kviz" className="btn btn-primary">
              Riješi EI Kviz →
            </Link>
            <Link to="/clanci" className="btn btn-secondary">
              Čitaj članke
            </Link>
          </div>
        </div>
      </section>

      {/* Manifest Section */}
      <section className="manifest">
        <div className="manifest-container">
          <h2 className="section-title">Manifest</h2>
          
          <div className="manifest-content">
            <p className="manifest-intro">
              <strong>Gukni Golube</strong> nije portal. Ovo je alat.
            </p>
            
            <p>
              Alat za sve koji su umorni od beskonačnih debata gdje svatko "osjeća" 
              da je u pravu, ali nitko ne donosi brojke.
            </p>

            <div className="manifest-rules">
              <h3>Naša pravila:</h3>
              
              <div className="rule">
                <span className="rule-number">1</span>
                <div className="rule-content">
                  <h4>Brojka ili gukni</h4>
                  <p>Svaka tvrdnja mora biti potkrijepljena provjerljivim podatkom. Nema "svi znaju", nema "očito je".</p>
                </div>
              </div>
              
              <div className="rule">
                <span className="rule-number">2</span>
                <div className="rule-content">
                  <h4>Nema besplatnog ručka</h4>
                  <p>Svaka "besplatna" usluga ima cijenu. Mi je izračunavamo i pokazujemo tko je plaća.</p>
                </div>
              </div>
              
              <div className="rule">
                <span className="rule-number">3</span>
                <div className="rule-content">
                  <h4>Trade-off je kralj</h4>
                  <p>Svaka odluka ima cijenu. Ne postoji "i ovce i novce". Pokazujemo što dobivaš i što gubiš.</p>
                </div>
              </div>
              
              <div className="rule">
                <span className="rule-number">4</span>
                <div className="rule-content">
                  <h4>Slijedi novac</h4>
                  <p>Kad ne razumiješ zašto se nešto događa, pogledaj tko zarađuje. Matematika ne laže.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Extraction Index Section */}
      <section className="ei-section">
        <div className="ei-container">
          <h2 className="section-title">Extraction Index (EI)</h2>
          
          <p className="ei-intro">
            Jedinstveni "biometrijski senzor mišljenja" - mjeri ne samo ŠTO misliš, 
            nego i KAKO razmišljaš o ekonomskim pitanjima.
          </p>
          
          <div className="ei-features">
            <div className="ei-feature">
              <span className="feature-icon">📊</span>
              <h4>10 pitanja</h4>
              <p>Realni scenariji iz hrvatskog života</p>
            </div>
            <div className="ei-feature">
              <span className="feature-icon">⏱️</span>
              <h4>~5 minuta</h4>
              <p>Brzo, ali duboko</p>
            </div>
            <div className="ei-feature">
              <span className="feature-icon">🧠</span>
              <h4>7 metrika</h4>
              <p>Kompleksna analiza tvog profila</p>
            </div>
          </div>
          
          <Link to="/kviz" className="btn btn-primary btn-large">
            Započni Extraction Index Kviz →
          </Link>
        </div>
      </section>

      {/* Author Section */}
      <section className="author-section">
        <div className="author-container">
          <h2 className="section-title">Tko stoji iza portala?</h2>
          
          <div className="author-content">
            <div className="author-info">
              <h3>Igor Grčman</h3>
              <p className="author-title">Fintech Expert | Bogotá, Kolumbija</p>
              
              <p>
                Više od 20 godina iskustva u globalnoj financijskoj tehnologiji. 
                Direktor tvrtke koja je prva u jugoistočnoj Europi dobila PCI DSS Level 1 certifikaciju.
              </p>
              
              <p>
                Bazu imam u Bogoti (Kolumbija), odakle vodim projekte za banke od Kariba do Latinske Amerike.
              </p>
              
              <p>
                Život u Južnoj Americi dao mi je "rendgenski vid" za ekonomiju. 
                Iz perspektive kontinenta gdje su ekonomske razlike brutalne i vidljive, 
                jasno prepoznajem iste uzorke ekstrakcije vrijednosti u Hrvatskoj - 
                samo što su kod nas vješto skriveni.
              </p>
              
              <p className="author-note">
                <em>Nisam aktivist ni političar. Poslovni sam stručnjak koji koristi 
                globalnu perspektivu da bi dekonstruirao lokalne hrvatske mitove.</em>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default HomePage;
